const antdTheme = {
  token: {
    colorBgContainer: "var(--tertiary-color)",
    colorBg: "var(--secondary-color)",
    colorPrimary: "var(--green-color)",
    colorSecondary: "var(--secondary-color)",
    colorLink: "var(--green-color)",
    colorText: "var(--white-color)",
    colorTextLight: "var(--white-color)",
    colorTextDark: "var(--white-color)",
    borderRadius: "var(--co-radius)",
    fontFamily: "var(--co-font-primary)",
    headerBg: "var(--primary-color)",

    //custom tokens
    subMenuIndent: "68px",
    subMenuOtherIndent: "18px",
    cardRadius: "var(--co-radius)",
  },
  components: {
    Tabs: {
      itemColor: "var(--white-color)",
      inkBarColor: "var(--green-color)",
      itemActiveColor: "var(--green-color)",
      itemHoverColor: "var(--green-color)",
      horizontalItemPadding: "2rem",
      fontFamily: "var(--co-font-primary)",
      colorSecondary: "var(--primary-color)",
      colorPrimary: "var(--green-color)",
      colorBg: "var(--secondary-color)",
      indicator: {
        align: "start",
      },
    },
    Card: {
      headerBg: "var(--primary-color)",
      headerColor: "var(--white-color)",
      colorBgContainer: "var(--tertiary-color)",
      colorBg: "var(--primary-color)",
      colorPrimary: "var(--green-color)",
      colorText: "var(--white-color)",
      borderRadius: "var(--co-radius)",
      fontFamily: "var(--co-font-primary)",
    },
    Menu: {
      itemColor: "var(--white-color)", // Default text color
      itemBg: "var(--primary-color)", // Default background
      fontFamily: "var(--co-font-primary)",
      subMenuItemBg: "var(--primary-color)", // Submenu background
      popupBg: "var(--primary-color)", // Popup background
      itemHoverColor: "var(--green-color)", // Hover text color
      itemHoverBg: "var(--very-dark-green-color)", // Hover background color
      subMenuItemHoverColor: "var(--green-color)", // Submenu hover text color
      subMenuItemHoverBg: "var(--very-dark-green-color)", // Submenu hover background color
      subMenuItemSelectedColor: "var(--green-color)", // Submenu active text color
      itemSelectedColor: "var(--green-color)", // Active text color
      itemSelectedBg: "var(--very-dark-green-color)", // Active background color
      colorPrimary: "var(--green-color)",
      colorSecondary: "var(--primary-color)",
      colorBgBase: "var(--primary-color)",
      colorBg: "var(--primary-color)",
      colorText: "var(--white-color)",
      itemDisabledColor: "var(--very-dark-green-color)",
    },
    Table: {
      headerBg: "var(--tertiary-color)",
      headerColor: "var(--white-color)",
      colorBgContainer: "var(--secondary-color)",
      colorPrimary: "var(--green-color)",
      colorText: "var(--white-color)",
      borderRadius: "var(--co-radius)",
      fontFamily: "var(--co-font-primary)",
      rowHoverBg: "var(--dark-green-color)",
    },
    Button: {
      colorPrimary: "var(--green-color)",
      colorBgContainer: "var(--tertiary-color)",
      colorText: "var(--white-color)",
      colorBorder: "var(--dark-green-color)",
      colorLink: "var(--green-color)",
      colorTextLightSolid: "var(--primary-color)",
      borderRadius: "var(--co-radius)",
      fontFamily: "var(--co-font-primary)",
      colorPrimaryActive: "var(--green-color)",
      // Hover states — stay on green, just subtly brighten
      colorPrimaryHover: "var(--green-color)",
      defaultHoverColor: "var(--green-color)",
      defaultHoverBorderColor: "var(--green-color)",
      defaultHoverBg: "var(--dark-green-color)",
      defaultActiveBg: "var(--very-dark-green-color)",
      defaultActiveColor: "var(--green-color)",
      defaultActiveBorderColor: "var(--green-color)",
      textTextHoverColor: "var(--green-color)",
      textHoverBg: "transparent",
      textTextColor: "var(--green-color)",
    },
    Form: {
      colorText: "var(--white-color)",
      colorTextHeading: "var(--white-color)",
      colorError: "#ff4d4f",
      fontFamily: "var(--co-font-primary)",
      labelColor: "var(--white-color)",
    },
    Layout: {
      headerBg: "var(--primary-color)",
      bodyBg: "var(--secondary-color)",
    },
    Drawer: {
      colorBgElevated: "var(--secondary-color)",
      colorText: "var(--white-color)",
      colorIcon: "var(--white-color)",
      colorIconHover: "var(--green-color)",
    },
    Dropdown: {
      colorBgElevated: "var(--tertiary-color)",
      colorText: "var(--white-color)",
      controlItemBgHover: "var(--dark-green-color)",
      controlItemBgActive: "var(--very-dark-green-color)",
    },
    Checkbox: {
      colorBgContainer: "var(--tertiary-color)",
      colorText: "var(--white-color)",
      colorBorder: "var(--dark-green-color)",
      colorPrimary: "var(--green-color)",
      colorPrimaryHover: "var(--green-color)",
    },
    Typography: {
      colorText: "var(--white-color)",
      colorTextSecondary: "var(--medium-light-grey-color)",
    },
    Spin: {
      colorPrimary: "var(--green-color)",
    },
    DatePicker: {
      colorBgContainer: "var(--tertiary-color)",
      colorBgElevated: "var(--tertiary-color)",
      colorText: "var(--white-color)",
      colorTextPlaceholder: "var(--medium-light-grey-color)",
      colorBorder: "var(--dark-green-color)",
      hoverBorderColor: "var(--green-color)",
      colorIcon: "var(--white-color)",
      colorIconHover: "var(--green-color)",
    },
    Modal: {
      contentBg: "var(--secondary-color)",
      headerBg: "var(--secondary-color)",
      titleColor: "var(--white-color)",
      colorText: "var(--white-color)",
      colorIcon: "var(--white-color)",
      colorIconHover: "var(--green-color)",
      footerBg: "var(--secondary-color)",
    },
    Input: {
      colorBgContainer: "var(--tertiary-color)",
      colorText: "var(--white-color)",
      colorTextPlaceholder: "var(--medium-light-grey-color)",
      colorBorder: "var(--dark-green-color)",
      hoverBorderColor: "var(--green-color)",
      activeBorderColor: "var(--green-color)",
    },
    Select: {
      colorText: "var(--white-color)",
      colorTextPlaceholder: "var(--medium-light-grey-color)",
      colorBgContainer: "var(--tertiary-color)",
      colorBgElevated: "var(--tertiary-color)",
      optionSelectedBg: "var(--very-dark-green-color)",
      optionSelectedColor: "var(--green-color)",
      optionActiveBg: "var(--dark-green-color)",
      colorBorder: "var(--dark-green-color)",
      colorPrimaryHover: "var(--green-color)",
      selectorBg: "var(--tertiary-color)",
      multipleItemBg: "var(--dark-green-color)",
      multipleItemColor: "var(--white-color)",
      colorIcon: "var(--white-color)",
      colorIconHover: "var(--green-color)",
    },
  },
};

export default antdTheme;
